module.exports = __webpack_public_path__ + "img/bg-cta.009b918a.svg";